// FIX: Moved the complete View enum to the top to avoid used-before-declaration errors and removed duplicates.
export enum View {
  Dashboard = "Dashboard",
  Home = "Home",
  Login = "Login",
  RoleSelection = "RoleSelection",

  // --- Free Features ---
  EnglishLab = "EnglishLab",
  Drawing = "Drawing",
  HistoryStoryteller = "HistoryStoryteller",
  LiteratureAssistant = "LiteratureAssistant",
  ScienceExplainer = "ScienceExplainer",
  TermsOfUse = "TermsOfUse",
  PrivacyPolicy = "PrivacyPolicy",
  CreditStore = "CreditStore",

  // Specific Features (Placeholders for now)
  Pronunciation = "Pronunciation",
  ClassroomToolbox = "ClassroomToolbox", // Hộp công cụ lớp học (không cần đăng nhập)

  // --- Logged-in Features ---
  TeacherTools = "TeacherTools", // Hub for logged-in teachers
  TeacherDashboard = "TeacherDashboard",
  ChildDashboard = "ChildDashboard",
  ParentDashboard = "ParentDashboard",
  StudentDashboard = "StudentDashboard",
  LearningModuleView = "LearningModuleView",
  ClassManagement = "ClassManagement",
  LessonPlanCreator = "LessonPlanCreator",
  QuizCreator = "QuizCreator",
  GameCreator = "GameCreator",
  SlideCreator = "SlideCreator",
  DocumentLibrary = "DocumentLibrary",
  HomeworkCreator = "HomeworkCreator",
  ActivityCreator = "ActivityCreator",
  VideoCreator = "VideoCreator",
  MasterSlideCreator = "MasterSlideCreator",
  Settings = "Settings",
  DocumentWorkspace = "DocumentWorkspace",
  DesignCenter = "DesignCenter",
  ComingSoon = "ComingSoon",
  TransactionHistory = "TransactionHistory",
  SKKNCreator = "SKKNCreator",
  YearPlanCreator = "YearPlanCreator",
  MeetingMinutes = "MeetingMinutes",
  ProfessionalPortfolio = "ProfessionalPortfolio",
  SharedLibrary = "SharedLibrary",
  CategoryDetailPage = "CategoryDetailPage",
  SharedResourceView = "SharedResourceView",
  AssignmentDetail = "AssignmentDetail",
  StudentAssignmentDetail = "StudentAssignmentDetail",
  UserGuide = "UserGuide",
  AboutApp = "AboutApp",
  AffiliateDashboard = "AffiliateDashboard",
  /** Trang GV (đã đăng nhập) nhận & xử lý lời mời tham gia làm đồng giáo viên của 1 lớp */
  TeacherJoinInvitation = "TeacherJoinInvitation",
  /** Trang GV (đã đăng nhập) nhận & xử lý lời mời tham gia 1 trường học (Phase 5.0) */
  SchoolJoinInvitation = "SchoolJoinInvitation",
  /** Trang quản lý trường học (School Organization) — tạo trường, mời/quản lý thành viên */
  SchoolManagement = "SchoolManagement",

  // --- Resource Viewers (Existing saved content) ---
  LessonPlanView = "LessonPlanView",
  LessonPlanEdit = "LessonPlanEdit",
  QuizView = "QuizView",
  QuizEdit = "QuizEdit",
  GameView = "GameView",
  GameEdit = "GameEdit",
  SlideView = "SlideView",
  SlideEdit = "SlideEdit",
  HomeworkView = "HomeworkView",
  HomeworkEdit = "HomeworkEdit",
  ActivityView = "ActivityView",
  ActivityEdit = "ActivityEdit",
  DrawingLessonView = "DrawingLessonView",
  DrawingLessonEdit = "DrawingLessonEdit",
  OralQuizCreator = "OralQuizCreator",
  OralQuizView = "OralQuizView",
  OralQuizEdit = "OralQuizEdit",
  OralQuizRunner = "OralQuizRunner",
  OralQuizHistory = "OralQuizHistory",
  /** S2 — Học sinh / phụ huynh làm đề thi thử online */
  OnlineQuizTaker = "OnlineQuizTaker",
  /** Kết quả 1 lượt làm đề (sau khi nộp) */
  QuizAttemptResult = "QuizAttemptResult",
  ScientificSimulationCreator = "ScientificSimulationCreator",
  ScientificSimulationView = "ScientificSimulationView",
  ScientificSimulationEdit = "ScientificSimulationEdit",
  /** Sơ đồ tư duy — hạt nhân kiến thức */
  MindmapStudio = "MindmapStudio",
  AILab = "AILab",
  AIEthics = "AIEthics",
  AIFactCheck = "AIFactCheck",
  CareerJourney = "CareerJourney",
  ThietKe3DCreator = "ThietKe3DCreator",
  ThietKe3DView = "ThietKe3DView",
  ThietKe3DEdit = "ThietKe3DEdit",
  InteractiveVideo = "InteractiveVideo",
  InteractiveVideoEdit = "InteractiveVideoEdit",
}

export interface Document {
  id: string;
  name: string;
  type: 'pdf' | 'docx' | 'pptx' | 'txt' | 'doc';
  uploadDate: string;
  status: 'draft' | 'published' | 'analyzing' | 'ready' | 'pending';
  // A mock content field for demonstration purposes. In a real app, this would be handled by a backend.
  content?: string;
  contentMarkdown?: string;
  content_markdown?: string;
  contentMeta?: Record<string, any>;
  content_meta?: Record<string, any>;
  conversionStatus?: 'pending' | 'converting' | 'ready' | 'failed' | 'fallback';
  conversion_status?: 'pending' | 'converting' | 'ready' | 'failed' | 'fallback';
  conversionQuality?: number;
  conversion_quality?: number;
  complexityScore?: number;
  complexity_score?: number;
  renderedPdfPath?: string;
  rendered_pdf_path?: string;
  nativeReady?: boolean;
  native_ready?: boolean;
  segments?: DocumentSegment[];
  sourceDocumentIds?: string[];
}

export interface DocumentSegment {
  title: string;
  content: string;
}

export interface ResourceSuggestions {
  videoLinks?: string[];
  imagePrompts?: string[];
  imageUrls?: string[];
}

/**
 * Một ô input cụ thể mà giáo viên có thể copy/paste vào ứng dụng AI.
 * Ví dụ: { label: "Tiêu đề phiên", value: "Nhận diện linh kiện điện…", multiline: false }
 */
export interface SuggestedActionCopyableInput {
  /** Tên trường trong ứng dụng đích (đúng nguyên văn nhãn UI khi có thể) */
  label: string;
  /** Nội dung điền sẵn — đã được AI viết sát với hoạt động trong giáo án */
  value: string;
  /** True nếu là textarea (mô tả dài), false/undefined cho input ngắn */
  multiline?: boolean;
  /** Ghi chú thêm để giáo viên hiểu trường này dùng để làm gì (tùy chọn) */
  hint?: string;
}

/**
 * Một bước trong hướng dẫn cầm tay chỉ việc.
 * Mỗi bước có thể kèm một hoặc nhiều ô input để copy.
 */
export interface SuggestedActionStep {
  /** Tiêu đề ngắn gọn, ví dụ: "Bước 2: Điền cấu hình thí nghiệm" */
  title: string;
  /** Mô tả hành động cần làm (1-2 câu, có động từ rõ ràng) */
  instruction?: string;
  /** Các ô input cần điền — mỗi ô có nút Sao chép riêng */
  copyableInputs?: SuggestedActionCopyableInput[];
}

/**
 * Một gợi ý sử dụng tính năng AI của hệ thống cho một hoạt động cụ thể trong giáo án.
 *
 * Ngoài 3 trường gốc (label/view/payload) để mở ứng dụng & tự động điền, AI có thể bổ sung
 * `appName`, `appUrl`, `whyUseful`, `steps`, `expectedOutcome` để tạo hướng dẫn step-by-step
 * sát với nội dung giáo án — giáo viên chỉ cần copy/paste là chạy được.
 */
export interface SuggestedAction {
  // --- Trường gốc (giữ tương thích ngược) ---
  label: string;
  view: string;
  payload: any;

  // --- Trường mới (tùy chọn): hướng dẫn cầm tay chỉ việc ---
  /** Tên hiển thị của ứng dụng (ví dụ: "Phòng Lab AI", "Mô phỏng khoa học") */
  appName?: string;
  /** Đường dẫn truy cập ứng dụng (ví dụ: "/phong-lab-ai") để giáo viên có thể bookmark/chia sẻ */
  appUrl?: string;
  /** Emoji/icon ngắn để nhận diện nhanh */
  icon?: string;
  /** 1-2 câu giải thích vì sao ứng dụng này phù hợp với HOẠT ĐỘNG này (không nói chung chung) */
  whyUseful?: string;
  /** Các bước hướng dẫn cụ thể, kèm sẵn nội dung điền */
  steps?: SuggestedActionStep[];
  /** Kết quả dự kiến giáo viên/học sinh sẽ nhận được sau khi làm theo các bước */
  expectedOutcome?: string;
}

export type AIProvider = 'gemini' | 'openai' | 'anthropic';

export interface LessonPlanStep {
  step: string;
  teacherActivity: string; // for old models
  studentActivity: string; // for old models
  teachingAids: string; // for old models
  duration: string;
  competencyGoals: string[]; // for old models

  // New fields for CV 5512 model
  objective?: string;
  content?: string;
  product?: string;
  implementation?: string;
  implementationRows?: LessonPlanImplementationRow[];
  suggestedActions?: SuggestedAction[];
  resourceSuggestions?: ResourceSuggestions;
}

export interface LessonPlanImplementationRow {
  phase: string;
  teacherStudentActivity: string[];
  expectedProduct: string[];
  images?: LessonPlanInlineImage[];
}

export interface LessonPlanInlineImage {
  url: string;
  caption?: string;
}

/**
 * Một trang/ảnh phân tích trong tập ảnh tài liệu đã được AI bóc tách (per-page).
 * Cho phép giáo viên chỉnh sửa transcription / key_points trực tiếp trên panel review.
 */
export interface TextbookImagePageMeta {
  pageIndex: number;
  imageId: number | string;
  imageName?: string;
  pageLabel?: string;
  transcription: string;
  keyPoints: string[];
  ocrConfidence?: 'high' | 'medium' | 'low';
}

/**
 * Cấu trúc tài liệu nguồn sinh ra từ phân tích đa ảnh tài liệu (multimodal AI).
 * Đính kèm vào LessonPlan để giáo viên có thể xem / sửa lại sau này.
 */
export interface TextbookImagesMeta {
  topic: string;
  subjectHint?: string;
  gradeHint?: string;
  textbookSetHint?: string;
  languageDetected?: string;
  summary: string;
  keyConcepts: { term: string; explanation: string }[];
  vocabulary?: { term: string; meaning: string }[];
  formulas?: { name: string; expression: string; note?: string }[];
  exercisesSeen?: string[];
  lessonObjectives: string[];
  perPage: TextbookImagePageMeta[];
  imageIds: (number | string)[];
  /**
   * Chế độ ghi chép đã dùng khi sinh meta:
   *  - true (mặc định): "Giữ nguyên gốc" — AI chép nguyên văn nội dung trong ảnh.
   *  - false: "Diễn đạt lại" — AI viết lại theo phong cách sư phạm.
   */
  verbatimMode?: boolean;
}

export interface LessonPlan {
  id: string;
  title: string;
  gradeLevel: GradeLevel;
  grade_level?: GradeLevel;
  subject: string;
  textbookSet?: TextbookSet;
  classLevel?: string; // VD: Lớp 1, Lớp 2...
  model: string;
  steps: LessonPlanStep[];
  savedDate: string;
  sourceDocumentId?: string;
  teachingDuration: number; // Changed to number (minutes)

  // New fields for CV 5512 model
  knowledgeObjective?: string;
  competencyObjective?: string;
  qualityObjective?: string;
  aiIntegrationNote?: string;
  digitalCompetencyNote?: string;
  equipmentAndMaterials?: string;
  buildMode?: 'ai' | 'manual';

  /** Chế độ tạo (ai | document | image). Lưu trên backend để hydrate panel review. */
  sourceMode?: 'ai' | 'document' | 'image';
  /** Văn bản bối cảnh đã sinh từ ảnh / tài liệu, dùng làm input cho AI. */
  sourceContent?: string;
  /** Danh sách ID ảnh trong thư viện đã dùng phân tích, đúng thứ tự người dùng chọn. */
  sourceImageIds?: (number | string)[];
  /** Toàn bộ kết quả phân tích đa ảnh tài liệu đã được giáo viên chỉnh sửa. */
  sourceTextbookMeta?: TextbookImagesMeta;
}

/**
 * Khung Năng lực số (NLS) cho học sinh phổ thông Việt Nam
 * theo Công văn 3456/BGDĐT-GDPT và Quyết định 4793/QĐ-BGDĐT.
 * Sử dụng để hiển thị checkbox lựa chọn trong Tạo Giáo án và đồng bộ với backend.
 */
export interface DigitalCompetencyArea {
  id: string;          // Mã miền (1, 2, 3, 4, 5, 6)
  name: string;        // Tên miền tiếng Việt
  short: string;       // Tên ngắn / English
  description: string; // Mô tả ngắn cho UI
}

export const DIGITAL_COMPETENCY_AREAS: DigitalCompetencyArea[] = [
  { id: '1', name: 'Khai thác dữ liệu và thông tin', short: 'Data & Info Literacy', description: 'Tìm kiếm, đánh giá, quản lý dữ liệu - thông tin - nội dung số.' },
  { id: '2', name: 'Giao tiếp và Hợp tác', short: 'Communication & Collaboration', description: 'Tương tác, chia sẻ, hợp tác, ứng xử trên mạng, danh tính số.' },
  { id: '3', name: 'Sáng tạo nội dung số', short: 'Digital Content Creation', description: 'Phát triển, tích hợp nội dung số, bản quyền, lập trình.' },
  { id: '4', name: 'An toàn', short: 'Safety', description: 'Bảo vệ thiết bị, dữ liệu cá nhân, sức khoẻ, môi trường.' },
  { id: '5', name: 'Giải quyết vấn đề', short: 'Problem Solving', description: 'Xử lý sự cố kỹ thuật, sáng tạo công nghệ, học tập suốt đời.' },
  { id: '6', name: 'Ứng dụng trí tuệ nhân tạo', short: 'AI Literacy', description: 'Hiểu, sử dụng và đánh giá AI có trách nhiệm.' },
];

/**
 * Bậc năng lực số tương ứng cấp lớp.
 */
export const DIGITAL_COMPETENCY_TIER_BY_GRADE: Record<string, { tier: string; label: string; grades: string }> = {
  TIEU_HOC: { tier: 'CB1-CB2', label: 'Cơ bản 1-2', grades: 'Lớp 1-5' },
  THCS: { tier: 'TC1-TC2', label: 'Trung cấp 1-2', grades: 'Lớp 6-9' },
  THPT: { tier: 'NC1', label: 'Nâng cao 1', grades: 'Lớp 10-12' },
  GDTX: { tier: 'NC1', label: 'Nâng cao 1', grades: 'Lớp 10-12' },
  MAM_NON: { tier: 'tiền-CB1', label: 'Tiền cơ bản', grades: 'Mầm non (làm quen)' },
};

/**
 * Loại câu hỏi của Đề kiểm tra (`Quiz`).
 *
 * Lưu ý quan trọng:
 * - Chuỗi enum giữ y nguyên cho 2 giá trị cũ (`Trắc nghiệm`, `Tự luận`) để KHÔNG vỡ
 *   dữ liệu Quiz đã lưu trong DB và các Quiz đang ở trạng thái draft.
 * - Các giá trị MỚI dùng tiếng Việt mô tả ngắn để vừa thân thiện với người dùng,
 *   vừa tự document khi xuất ra Word/PDF.
 * - Cấu trúc câu hỏi mới đáp ứng đề TN THPT (3 phần I/II/III) theo
 *   QĐ 764/QĐ-BGDĐT 2024: I. Trắc nghiệm 4 lựa chọn — II. Trắc nghiệm đúng/sai 4 ý —
 *   III. Trả lời ngắn; đồng thời bám Thông tư 22/2021/TT-BGDĐT về kiểm tra
 *   đánh giá học sinh THCS, THPT.
 */
export enum QuestionType {
  /** Phần I (TN THPT, QĐ 764) – Trắc nghiệm 4 lựa chọn 1 đáp án đúng */
  MultipleChoice    = "Trắc nghiệm",
  /** Phần II (TN THPT, QĐ 764) – Mỗi câu có 4 ý a/b/c/d, mỗi ý chọn Đúng hoặc Sai */
  TrueFalseGroup    = "Trắc nghiệm Đúng/Sai (4 ý)",
  /** Phần III (TN THPT, QĐ 764) – Trả lời ngắn dạng số/biểu thức */
  NumericShort      = "Trả lời ngắn (số)",
  /** Tự luận ngắn (dùng cho kiểm tra thường xuyên/định kỳ truyền thống) */
  ShortAnswer       = "Tự luận",
  /** Tự luận dài / Nghị luận – Văn / Sử / GDCD / KHXH */
  EssayLong         = "Tự luận dài / Nghị luận",
  /** Điền vào chỗ trống (1 hoặc nhiều ô) – phù hợp Tiểu học, Tiếng Anh, Văn */
  FillBlank         = "Điền vào chỗ trống",
  /** Ghép cặp (A↔B) – phù hợp Sử, Địa, Sinh, Anh từ vựng */
  Matching          = "Ghép cặp",
  /** Sắp xếp thứ tự đúng – phù hợp Sử (sự kiện), Sinh (quy trình), Văn (cốt truyện) */
  Ordering          = "Sắp xếp thứ tự",
  /** Cụm câu hỏi cùng 1 ngữ liệu (đoạn văn/biểu đồ/bảng số liệu) */
  ReadingPassage    = "Cụm câu hỏi theo ngữ liệu",
  /** Câu hỏi nghe (audio đính kèm) – môn Tiếng Anh / Ngoại ngữ */
  Listening         = "Câu hỏi nghe (audio)",
}

/** Bảng nhãn rút gọn dùng cho UI ma trận / xuất file */
export const QUESTION_TYPE_SHORT_LABEL: Record<QuestionType, string> = {
  [QuestionType.MultipleChoice]: 'TN 4 đáp án',
  [QuestionType.TrueFalseGroup]: 'Đúng/Sai (4 ý)',
  [QuestionType.NumericShort]:   'Trả lời ngắn',
  [QuestionType.ShortAnswer]:    'Tự luận ngắn',
  [QuestionType.EssayLong]:      'Tự luận dài',
  [QuestionType.FillBlank]:      'Điền khuyết',
  [QuestionType.Matching]:       'Ghép cặp',
  [QuestionType.Ordering]:       'Sắp xếp',
  [QuestionType.ReadingPassage]: 'Theo ngữ liệu',
  [QuestionType.Listening]:      'Câu hỏi nghe',
};

export enum Difficulty {
  Easy = "Dễ",
  Medium = "Trung bình",
  Hard = "Khó"
}

/** 1 ý trong Trắc nghiệm Đúng/Sai (Phần II — TN THPT, QĐ 764). 4 ý / câu. */
export interface SubStatement {
  id: 'a' | 'b' | 'c' | 'd';
  statement: string;
  isTrue: boolean;
  /** Giải thích riêng cho ý này (tùy chọn) */
  explanation?: string;
}

/** Cấu hình đáp án dạng số cho `NumericShort` */
export interface NumericAnswer {
  value: number;
  /** Sai số chấp nhận được, ví dụ 0.01 */
  tolerance?: number;
  /** Đơn vị nếu có, ví dụ "m/s", "kg", "%" */
  unit?: string;
}

/** Một ô trống trong câu `FillBlank` */
export interface FillBlankSlot {
  /** Placeholder hiển thị trong câu, ví dụ "[___1___]" */
  placeholder: string;
  /** Tất cả đáp án được chấp nhận (đồng nghĩa) */
  acceptedAnswers: string[];
  caseSensitive?: boolean;
}

/** 1 cặp Match cho `Matching` */
export interface MatchPair {
  left: string;
  right: string;
}

/** 1 mục cho `Ordering` */
export interface OrderingItem {
  id: string;
  text: string;
  /** Thứ tự đúng (0-indexed) */
  correctIndex: number;
}

/** Tệp media đính kèm câu hỏi (ảnh/đồ thị/audio/video) */
export interface QuestionMedia {
  type: 'image' | 'audio' | 'video';
  url: string;
  caption?: string;
}

export interface Question {
  questionText: string;
  questionType: QuestionType;
  /** Đáp án trắc nghiệm 4 lựa chọn (chỉ cho `MultipleChoice`) */
  options?: string[];
  /**
   * Đáp án đúng dưới dạng chuỗi.
   * - `MultipleChoice`: trùng nguyên văn 1 phương án trong `options`.
   * - `TrueFalseGroup`: tổng hợp dạng "a) Đ, b) S, c) Đ, d) S" (đồng thời `subStatements` chứa
   *   chi tiết cấu trúc).
   * - `NumericShort`: chuỗi của `numericAnswer.value`.
   * - Các loại khác: chuỗi mô tả đáp án ngắn (giáo viên/AI có thể cập nhật).
   */
  correctAnswer: string;
  explanation: string;
  // — đã có (matrix alignment) —
  topic?: string;
  cognitiveLevel?: CognitiveLevel;

  // ─── Mở rộng v2 (đều OPTIONAL, không vỡ Quiz cũ) ───────────────────
  /** Điểm câu (khớp với ma trận). Nếu không set, hệ thống tính dựa trên đặc tả. */
  points?: number;
  /** Lời giải chi tiết tách khỏi `explanation` ngắn (xuất ra "File lời giải") */
  detailedSolution?: string;
  /** `TrueFalseGroup`: 4 ý a/b/c/d kèm Đ/S */
  subStatements?: SubStatement[];
  /** `NumericShort`: cấu hình đáp án dạng số */
  numericAnswer?: NumericAnswer;
  /** `FillBlank`: vị trí ô trống & đáp án chấp nhận */
  blanks?: FillBlankSlot[];
  /** `Matching`: cặp ghép trái-phải */
  matchPairs?: MatchPair[];
  /** `Ordering`: các mục cần sắp xếp */
  orderingItems?: OrderingItem[];
  /** `ReadingPassage`/`Listening`: id của ngữ liệu chung trong `Quiz.passages` */
  passageId?: string;
  /** Media đính kèm (ảnh đồ thị, audio nghe, video minh hoạ) */
  media?: QuestionMedia[];
  /** Tag năng lực số (CV 3456) áp dụng cho câu, ví dụ ['2.3.CB1', '4.2.CB1'] */
  digitalCompetencyTags?: string[];
  /** Tag năng lực AI (CV 3439) áp dụng cho câu */
  aiCompetencyTags?: ('AI1' | 'AI2' | 'AI3' | 'AI4')[];
  /** ID nhóm biến thể (khi sinh nhiều mã đề từ 1 đề gốc) */
  variantGroupId?: string;
}

export enum QuizSystem {
  CONG_LAP = "Hệ công lập (GDPT 2018)",
  TU_THUC = "Hệ tư thục & song ngữ",
}

export enum QuizCategory {
  // Công lập
  THUONG_XUYEN = "Kiểm tra thường xuyên",
  DINH_KY = "Kiểm tra định kỳ",
  THI_CHUYEN_CAP = "Thi tuyển sinh / Tốt nghiệp",
  NANG_LUC = "Đánh giá năng lực",
  // Tư thục
  QUOC_TE = "Kiểm tra quốc tế/chuẩn hóa",
  DU_AN = "Kiểm tra theo dự án",
  KY_NANG_MEM = "Kiểm tra kỹ năng mềm (4Cs)",
  LIEN_MON = "Kiểm tra tích hợp - liên môn",
  CONG_NGHE_SO = "Kiểm tra công nghệ số",
}

export enum QuizFormat {
    // Thường xuyên
    HOI_DAP = "Hỏi – đáp (miệng)",
    TRAC_NGHIEM_NHANH = "Trắc nghiệm nhanh",
    THUC_HANH_QUAN_SAT = "Thực hành / Quan sát",
    // Định kỳ
    TU_LUAN = "Tự luận",
    TRAC_NGHIEM_KHACH_QUAN = "Trắc nghiệm khách quan",
    KET_HOP_TU_LUAN_TRAC_NGHIEM = "Kết hợp Tự luận & Trắc nghiệm",
    THUC_HANH_THI_NGHIEM = "Thực hành / Thí nghiệm",
    // Năng lực
    PORTFOLIO = "Đánh giá qua hồ sơ học tập (portfolio)",
    HOAT_DONG_NHOM = "Đánh giá hoạt động nhóm/dự án",
    // Dự án
    SAN_PHAM_HOC_TAP = "Đánh giá sản phẩm học tập",
    // Kỹ năng mềm
    RUBRIC_QUAN_SAT = "Đề xuất bảng rubric quan sát",
    // Công nghệ số
    QUIZ_ONLINE = "Quiz trực tuyến (Kahoot, Quizizz...)",
    // Quốc tế
    CAMBRIDGE_MAP = "Cambridge Checkpoint, MAP test",
    SAT_ACT_IELTS = "SAT, ACT, IELTS/TOFL...",
    // Liên môn
    DU_AN_LIEN_MON = "Dự án liên môn",
}

export const quizTaxonomy: Record<QuizSystem, { value: QuizCategory, label: string, formats: {value: QuizFormat, label: string}[]}[]> = {
  [QuizSystem.CONG_LAP]: [
    { value: QuizCategory.THUONG_XUYEN, label: "Kiểm tra thường xuyên", formats: [
      { value: QuizFormat.HOI_DAP, label: "Hỏi – đáp (miệng)" },
      { value: QuizFormat.TRAC_NGHIEM_NHANH, label: "Trắc nghiệm nhanh, câu hỏi ngắn" },
      { value: QuizFormat.THUC_HANH_QUAN_SAT, label: "Thực hành / Quan sát" },
    ]},
    { value: QuizCategory.DINH_KY, label: "Kiểm tra định kỳ", formats: [
      { value: QuizFormat.TU_LUAN, label: "Tự luận" },
      { value: QuizFormat.TRAC_NGHIEM_KHACH_QUAN, label: "Trắc nghiệm khách quan" },
      { value: QuizFormat.KET_HOP_TU_LUAN_TRAC_NGHIEM, label: "Kết hợp Tự luận & Trắc nghiệm" },
      { value: QuizFormat.THUC_HANH_THI_NGHIEM, label: "Thực hành / Thí nghiệm" },
    ]},
     { value: QuizCategory.THI_CHUYEN_CAP, label: "Thi tuyển sinh / Tốt nghiệp", formats: [
      { value: QuizFormat.TU_LUAN, label: "Tự luận" },
      { value: QuizFormat.TRAC_NGHIEM_KHACH_QUAN, label: "Trắc nghiệm khách quan" },
      { value: QuizFormat.KET_HOP_TU_LUAN_TRAC_NGHIEM, label: "Kết hợp Tự luận & Trắc nghiệm" },
    ]},
    { value: QuizCategory.NANG_LUC, label: "Đánh giá năng lực", formats: [
      { value: QuizFormat.PORTFOLIO, label: "Qua hồ sơ học tập (portfolio)" },
      { value: QuizFormat.HOAT_DONG_NHOM, label: "Qua hoạt động nhóm, dự án" },
    ]},
  ],
  [QuizSystem.TU_THUC]: [
    { value: QuizCategory.QUOC_TE, label: "Kiểm tra quốc tế/chuẩn hóa", formats: [
      { value: QuizFormat.CAMBRIDGE_MAP, label: "Cambridge Checkpoint, MAP test" },
      { value: QuizFormat.SAT_ACT_IELTS, label: "SAT, ACT, IELTS/TOEFL..." },
    ]},
    { value: QuizCategory.DU_AN, label: "Kiểm tra theo dự án", formats: [
      { value: QuizFormat.SAN_PHAM_HOC_TAP, label: "Sản phẩm học tập (poster, thuyết trình...)" },
      { value: QuizFormat.PORTFOLIO, label: "Hồ sơ năng lực (portfolio)" },
    ]},
    { value: QuizCategory.KY_NANG_MEM, label: "Kiểm tra kỹ năng mềm (4Cs)", formats: [
      { value: QuizFormat.RUBRIC_QUAN_SAT, label: "Đánh giá qua quan sát, bảng rubric" },
    ]},
    { value: QuizCategory.LIEN_MON, label: "Kiểm tra tích hợp - liên môn", formats: [
      { value: QuizFormat.DU_AN_LIEN_MON, label: "Dự án liên môn (ví dụ: Thành phố xanh)" },
    ]},
    { value: QuizCategory.CONG_NGHE_SO, label: "Kiểm tra công nghệ số", formats: [
      { value: QuizFormat.QUIZ_ONLINE, label: "Quiz trực tuyến (Kahoot, Quizizz...)" },
    ]},
  ],
};

// New types for Matrix-based Quiz Creation
export type CognitiveLevel = 'Nhận biết' | 'Thông hiểu' | 'Vận dụng' | 'Vận dụng cao';

export const COGNITIVE_LEVELS: CognitiveLevel[] = ['Nhận biết', 'Thông hiểu', 'Vận dụng', 'Vận dụng cao'];

export interface MatrixCell {
    mcCount: number; // Multiple Choice count
    saCount: number; // Short Answer count
    points: number;
}

export interface MatrixRow {
    topic: string;
    standards: string;
    levels: Record<CognitiveLevel, MatrixCell>;
}

export interface SpecificationItem {
    id: string; // Add for React key
    requirement: string; // Yêu cầu cần đạt
    cognitiveLevel: CognitiveLevel;
    questionFormat: string; // Hình thức câu hỏi
    questionCount: number;
    points: number;
    notes: string; // Ghi chú
}

export interface SpecificationTopic {
    topic: string;
    standards: string;
    items: SpecificationItem[];
}

export enum TeachingModel {
  FiveE = "Mô hình 5E",
  PBL = "Dạy học theo dự án (PBL)",
  Flipped = "Lớp học đảo ngược",
  STEM = "STEM/STEAM",
  GDPT_2018_5512 = "GDPT 2018 (theo CV 5512 & CV 3439)",
  VNEN = "Mô hình VNEN"
}

// ═══════════════════════════════════════════════════════════════════════════
// TEST PURPOSE PRESET (v2) — đã chuyển sang feature `quiz-creator-v2`
// ═══════════════════════════════════════════════════════════════════════════
//
// Các định nghĩa `TestPurposeId`, `TestAudience`, `TestPurposePreset`,
// `TEST_PURPOSE_PRESETS`, `getTestPurposePresetsByAudience`,
// `getTestPurposePresetById` đã được di chuyển vào module riêng:
//
//   import { ... } from '@/features/quiz-creator-v2';
//
// `Quiz` interface bên dưới giữ kiểu loose (`purposePreset?: string`,
// `audience?: UserRole`) để tránh circular import giữa types core và feature.

// ═══════════════════════════════════════════════════════════════════════════
// QUIZ INTERFACE (mở rộng v2)
// ═══════════════════════════════════════════════════════════════════════════

/** Cấu hình mã đề / biến thể (1 đề gốc → nhiều mã đề chống chép bài) */
export interface QuizVariant {
  /** Mã đề: 'A' | 'B' | 'C' | 'D' (hoặc số) */
  code: string;
  /** Hoán vị thứ tự câu so với đề gốc, ví dụ [0, 3, 1, 2] */
  questionOrder: number[];
  /** Hoán vị thứ tự đáp án trong từng câu (key = chỉ số câu trong đề gốc) */
  optionOrders?: Record<number, number[]>;
}

/** Cấu hình chế độ làm bài online (HS làm trên web → tự chấm) */
export interface QuizOnlineConfig {
  enabled: boolean;
  /** Hiển thị đáp án sau khi nộp bài? */
  showAnswerAfterSubmit: boolean;
  /** Giới hạn thời gian (phút). Nếu trùng với `Quiz.duration` thì kế thừa. */
  timeLimit?: number;
  /** Xáo thứ tự câu khi load? */
  shuffleQuestions?: boolean;
  /** Xáo thứ tự đáp án trong từng câu? */
  shuffleOptions?: boolean;
  /** Cho phép làm lại nhiều lần? */
  allowRetake?: boolean;
}

/** Mục tiêu phân hoá độ khó theo CV 7991 (validator cảnh báo nếu vượt) */
export interface DifficultyTargets {
  /** Tối đa % câu Nhận biết (thường ≤ 40%) */
  nbMaxPercent?: number;
  /** Tối thiểu % câu Vận dụng + Vận dụng cao (thường ≥ 30%) */
  vdMinPercent?: number;
  /** Tối đa % câu Vận dụng cao (thường ≤ 20%) */
  vdcMaxPercent?: number;
}

/**
 * Phong cách / hình dạng đề — KHÁC với mức độ khó.
 *  - auto:        suy theo `purposePreset` + `examTarget`
 *  - mcq_heavy:   nhiều trắc nghiệm, ít/không tự luận (đề thi thật phổ thông, ôn thi nhanh)
 *  - mixed:       cân bằng trắc nghiệm + tự luận ngắn (đề kiểm tra định kỳ thường)
 *  - essay_heavy: 5-10 câu tự luận sâu, có hướng dẫn chấm chi tiết
 *  - olympiad:    4-7 câu LỚN, mỗi câu nhiều sub-câu (a/b/c), độ sâu cao, làm 25-40
 *                 phút/câu (đề HSG, đề thi vào CHUYÊN, đề chuyên đề nâng cao)
 *  - exam_thpt:   cấu trúc 3 phần I/II/III theo QĐ 764/QĐ-BGDĐT 2024 (TN THPT)
 *
 * Style quyết định CẢ "số câu hỏi vs thời lượng" lẫn "độ sâu mỗi câu" —
 * KHÔNG được suy chỉ từ `duration` hay `questionCount` đơn lẻ.
 */
export type ExamStyle =
  | 'auto'
  | 'mcq_heavy'
  | 'mixed'
  | 'essay_heavy'
  | 'olympiad'
  | 'exam_thpt';

/**
 * Profile mức độ khó cho QUICK FLOW (S/P). Backend sẽ map → tỉ lệ NB/TH/VD/VDC.
 *  - auto:     mặc định, suy theo `purposePreset` (S2 → exam, S4 → remedial, P2/P3 → easy, …)
 *  - easy:     NB 50, TH 35, VD 15, VDC 0
 *  - standard: NB 30, TH 40, VD 25, VDC 5
 *  - advanced: NB 20, TH 30, VD 35, VDC 15
 *  - exam:     NB 20, TH 30, VD 35, VDC 15 (giống advanced nhưng prompt nghiêm hơn)
 *  - adaptive: NB 25, TH 35, VD 30, VDC 10, sắp xếp tăng dần
 *  - remedial: NB 45, TH 35, VD 20, VDC 0
 */
export type DifficultyProfile =
  | 'auto'
  | 'easy'
  | 'standard'
  | 'advanced'
  | 'exam'
  | 'adaptive'
  | 'remedial';

/** Mục tiêu % phân bổ NB/TH/VD/VDC do UI tự định nghĩa (override `difficultyProfile`). */
export interface DifficultyMixTargets {
  NB?: number;
  TH?: number;
  VD?: number;
  VDC?: number;
}

/** Ngữ liệu chung cho cụm câu hỏi (`ReadingPassage` / `Listening`) */
export interface QuizPassage {
  id: string;
  title: string;
  /** Nguồn trích dẫn (ngoài SGK theo CV 3175 với môn Văn) */
  sourceCitation: string;
  /** Nội dung văn bản (markdown / plain) — hoặc URL audio nếu là listening */
  content: string;
  /** Loại ngữ liệu */
  kind?: 'text' | 'audio' | 'image' | 'table' | 'chart';
}

export interface Quiz {
  id: string;
  title: string;
  gradeLevel: GradeLevel;
  grade_level?: GradeLevel;
  subject: string;
  classLevel?: string;
  textbookSet?: TextbookSet;
  questions: Question[];
  savedDate: string;

  // Old fields for simple creator
  system?: QuizSystem;
  category?: QuizCategory;
  format?: QuizFormat;

  // New fields for matrix-based creator
  scopeAndStandards?: string; // Replaces contentTopics
  matrix?: MatrixRow[];
  specification?: SpecificationTopic[];
  duration?: number; // in minutes
  /** Số câu hỏi mục tiêu (quick-flow S1/S2) — gửi kèm khi sinh đề nhanh */
  questionCount?: number;
  gradingGuide?: string; // Rubric for essay questions
  teachingModel?: TeachingModel;
  sourceMode?: 'ai' | 'document' | 'image';
  sourceContent?: string;
  selectedSourceIds?: string[];
  sourceDocumentIds?: string[];
  selectedResource?: { type: SourceItemType; id: string } | null;
  aiProvider?: AIProvider;
  allowAiAugmentation?: boolean;
  currentStep?: number;
  status?: 'draft' | 'published' | 'ready';
  isSample?: boolean;
  buildMode?: 'ai' | 'manual';

  // ─── Mở rộng v2 (đều OPTIONAL, không vỡ Quiz cũ) ───────────────────
  /**
   * Preset use-case đã chọn ở Step 0 (T1..T9 / P1..P4 / S1..S4).
   *
   * Kiểu giữ ở dạng `string` để Quiz core không phụ thuộc vào module feature
   * `quiz-creator-v2` (tránh circular import). Validate runtime bằng helper
   * `getTestPurposePresetById()` của feature trước khi tin dùng.
   */
  purposePreset?: string;
  /** Vai trò người tạo đề – dùng để render UI khác nhau cho từng đối tượng */
  audience?: UserRole;
  /** Năm học áp dụng – từ 2026-2027 chỉ còn 1 bộ KNTT (QĐ 3588/QĐ-BGDĐT) */
  schoolYear?: string;
  /** Chương SGK cụ thể (ví dụ "Chương III") */
  textbookChapter?: string;
  /** Bài SGK cụ thể (ví dụ "Bài 8") */
  textbookLesson?: string;
  /** Năng lực số (CV 3456) áp dụng cho đề – ID lấy từ DIGITAL_COMPETENCY_AREAS */
  digitalCompetencyAreas?: string[];
  /** Bậc năng lực số (CB1 / CB2 / TC1 / TC2 / NC1) */
  digitalCompetencyTier?: string;
  /** Năng lực AI (CV 3439) áp dụng cho đề */
  aiCompetencies?: ('AI1' | 'AI2' | 'AI3' | 'AI4')[];
  /** Ngữ liệu chung (cho cụm câu hỏi `ReadingPassage`/`Listening`) */
  passages?: QuizPassage[];
  /** Mã đề / biến thể (1 đề gốc → nhiều mã đề chống chép bài) */
  variants?: QuizVariant[];
  /** Chế độ phiếu trả lời khi xuất file in */
  answerSheetMode?: 'inline' | 'separate' | 'omr_qr';
  /** Cấu hình làm bài online */
  onlineMode?: QuizOnlineConfig;
  /** Mục tiêu phân hoá độ khó (CV 7991) */
  difficultyTargets?: DifficultyTargets;
  /** Profile mức độ khó quick-flow (S/P) — backend map sang tỉ lệ NB/TH/VD/VDC */
  difficultyProfile?: DifficultyProfile;
  /** Override % NB/TH/VD/VDC (chỉ ưu tiên hơn `difficultyProfile` khi user chỉnh thủ công) */
  difficultyMix?: DifficultyMixTargets;
  /** Phong cách / shape of đề (xem `ExamStyle` JSDoc) — ưu tiên hơn `questionCount` heuristic */
  examStyle?: ExamStyle;
  /**
   * Kỳ thi mục tiêu — `TS10` (vào 10) | `TS10_CHUYEN` (vào 10 CHUYÊN) | `TN_THPT`
   * (Tốt nghiệp THPT) | `KHAO_SAT` (khảo sát đầu vào) | `OLYMPIAD`. Backend
   * `GenerateService::resolveExamStyle` đọc field này để chọn phong cách đề + few-shot
   * + cấu trúc tự động (vd TN_THPT → 3 phần I/II/III). Không gửi field nếu user luyện
   * theo chuyên đề tự do (UI hiển thị `CHUYEN_DE`).
   */
  examTarget?: string;
  /** ID con (parent_children) – dùng khi audience='parent' để gắn đề với lộ trình của con */
  childId?: string;
  /**
   * Cờ đánh dấu đề theo cấu trúc 3 phần TN THPT (QĐ 764/QĐ-BGDĐT 2024).
   * Khi true, backend sẽ sinh đề với 3 phần:
   * - Phần I: Trắc nghiệm 4 đáp án
   * - Phần II: Đúng/Sai (4 ý)
   * - Phần III: Trả lời ngắn (số)
   */
  isThpt2025Structure?: boolean;
  /** ID sơ đồ tư duy nguyên liệu — backend bơm outline vào prompt để AI bám sát phạm vi kiến thức */
  mindmapId?: string;
}

// FIX: Removed duplicate GradeLevel and GameType enums. The correct ones are defined below.
export enum GradeLevel {
  MAM_NON = "Mầm non",
  TIEU_HOC = "Tiểu học",
  THCS = "THCS",
  THPT = "THPT",
  GDTX = "GDTX",
  DAI_HOC = "Đại học/Cao đẳng"
}

export enum TextbookSet {
  KET_NOI_TRI_THUC = "Kết nối tri thức với cuộc sống",
  CHAN_TROI_SANG_TAO = "Chân trời sáng tạo",
  CANH_DIEU = "Cánh diều",
  KHAC = "Khác (Tự biên soạn/Quốc tế)"
}

export enum GameType {
  DONG_THOI_GIAN = "Dòng thời gian",
  // Mầm non
  TIM_MAU_TIM_HINH = "Tìm màu – tìm hình",
  BE_BAT_CHUOC = "Bé bắt chước",
  GHEP_HINH_GHEP_CHU = "Ghép hình – ghép chữ cái",
  VONG_QUAY_AM_NHAC = "Vòng quay âm nhạc",
  // Tiểu học
  AI_NHANH_HON = "Ai nhanh hơn",
  O_CHU_BI_MAT = "Ô chữ bí mật",
  TRUY_TIM_KHO_BAU = "Truy tìm kho báu",
  GHEP_DOI_THONG_TIN = "Ghép đôi thông tin",
  // THCS
  AI_LA_TRIEU_PHU_MINI = "Ai là triệu phú mini",
  DONG_VAI_TINH_HUONG = "Đóng vai tình huống",
  TIEP_SUC = "Tiếp sức",
  DO_VUI_LINH_HOAT = "Đố Vui Linh hoạt",
  // THPT
  TRANH_BIEN_NHANH = "Tranh biện nhanh",
  GIAI_MA_O_CHU = "Giải mã ô chữ",
  CASE_STUDY_NHO = "Case study nhỏ",
  AI_LA_NHA_KHOA_HOC_TRE = "Ai là nhà khoa học trẻ",
  DEBATE = "Debate",
  DU_AN_MINI = "Dự án mini",
  PEER_TEACHING = "Peer teaching",
  CASE_STUDY_NHOM = "Case study nhóm",
  // from old list
  BINGO_KIEN_THUC = "Bingo kiến thức",
  // Trò chơi đa môn (universal) - bổ sung
  PHAN_LOAI_NHOM = "Phân loại nhóm",
  DUNG_SAI = "Đúng - Sai nhanh",
  DIEN_KHUYET = "Điền vào chỗ trống",
  LAT_THE_TIM_CAP = "Lật thẻ tìm cặp",
  SAP_XEP_THU_TU = "Sắp xếp thứ tự",
  TIM_TU_AN = "Tìm từ ẩn",
  // Game mới - Priority 1 (theo docs/nghiep-vu/de-xuat-game-tuong-tac-moi-gamecreator.md)
  DAU_BOSS_CUOI_BAI = "Đấu Boss Cuối Bài",
  PHA_AN_HOC_DUONG = "Phá Án Học Đường",
  HANH_TRINH_BAN_DO = "Hành Trình Bản Đồ Tri Thức",
  WORDLE_MON_HOC = "Wordle Môn Học",
}


export interface GameFramework {
  type: GameType;
  objective: string;
  duration: string;
  preparation: string;
  howToPlay: string;
  evaluation: string;
  variation: string;
  configurableSettings?: {
    key: string;
    label: string;
    type: 'number' | 'text' | 'select' | 'boolean';
    defaultValue: any;
    options?: Array<{ value: string | number | boolean; label: string }>;
  }[];
}

export interface Game {
    id: string;
    title: string;
    gradeLevel: GradeLevel;
    grade_level?: GradeLevel;
    subject?: string;
    classLevel?: string;
    textbookSet?: TextbookSet;
    gameType: GameType;
    game_type?: GameType;
    topic: string;
    content: any; // Can be string[], {term: string, definition: string}[], etc.
    rules?: string; // Rules can be static from framework
    settings?: Record<string, any>;
    savedDate: string;
    saved_date?: string;
    sourceLessonPlanId?: string;
    sourceDocumentId?: string;
    sourcePresentationId?: string;
    originatingTask?: string; // To link back to a contextual action
    visibility?: 'private' | 'link' | 'public' | 'restricted';
    isSample?: boolean;
    buildMode?: 'ai' | 'manual';
}

export enum SlideLayoutType {
    Title = 'TITLE', // Slide 1: Trang Bìa
    Agenda = 'AGENDA', // Slide 2: Mục lục & Mục tiêu
    WarmUp = 'WARM_UP', // Slide 3: Hoạt động khởi động
    Concept = 'CONCEPT', // Slide 4: Khái niệm & Định nghĩa
    Analysis = 'ANALYSIS', // Slide 5: Phân tích chuyên sâu
    Comparison = 'COMPARISON', // Slide 6: So sánh & Đối chiếu
    MultipleChoice = 'MULTIPLE_CHOICE', // Slide 7: Bài tập trắc nghiệm
    GroupDiscussion = 'GROUP_DISCUSSION', // Slide 8: Thảo luận nhóm
    DataAnalysis = 'DATA_ANALYSIS', // Slide 9: Phân tích dữ liệu
    Summary = 'SUMMARY' // Slide 10: Tổng kết & Giao việc
}

/**
 * Bảng màu của một preset thiết kế slide. Tất cả là màu hex (#rrggbb).
 * Dùng chung cho cả web preview, PPTX export và HTML5 generation (qua designPresetSpec).
 */
export interface SlidePresetPalette {
    primary: string;
    secondary: string;
    accent: string;
    text: string;
    background: string;
    surface: string;
}

/** Cấu hình typography cho preset. Font name khớp với Google Fonts hoặc system font. */
export interface SlidePresetTypography {
    headingFont: string;
    bodyFont: string;
    /** Hệ số phóng to heading so với body, vd 1.6 → heading 1.6× kích thước body. */
    headingScale: number;
    lineHeight: number;
}

/** Bộ icon: ảnh hưởng renderer chọn icon set tương ứng. */
export type SlidePresetIconSet = 'flat' | '3d' | 'outline' | 'sticker';

/** Tag đối tượng người xem chính của preset. */
export type SlidePresetAudienceTag = 'primary' | 'secondary' | 'adult' | 'parent' | 'student' | 'teacher';

/** Tag môn học chính. */
export type SlidePresetSubjectTag = 'stem' | 'language' | 'social' | 'art' | 'general';

/**
 * Hint layout cho từng `SlideLayoutType` trong preset. Web renderer + PPTX engine
 * sẽ đọc các field này để chọn variant phù hợp. Tất cả optional → fallback default.
 */
export interface SlidePresetLayoutHint {
    /** Vị trí khối text chính trên slide. */
    textPosition?: 'left' | 'right' | 'top' | 'bottom' | 'center';
    /** Vị trí ảnh minh hoạ (nếu có). */
    imagePosition?: 'left' | 'right' | 'top' | 'bottom' | 'background';
    /** Số cột text/grid (vd. comparison: 2, analysis: 1–3). */
    columns?: number;
    /** Decoration nhấn nhá (corner shape, divider, ribbon...). */
    accents?: ('corner' | 'divider' | 'ribbon' | 'pattern' | 'gradient')[];
}

/**
 * Định nghĩa một preset thiết kế slide hoàn chỉnh. Lưu trong catalog (TS + PHP)
 * và có thể được preset picker chọn cho cả presentation hoặc per-slide override.
 */
export interface SlideDesignPreset {
    id: string;
    name: string;
    description?: string;
    audienceTags: SlidePresetAudienceTag[];
    subjectTags: SlidePresetSubjectTag[];
    moodTags: string[];
    palette: SlidePresetPalette;
    typography: SlidePresetTypography;
    iconSet: SlidePresetIconSet;
    /** Map từ SlideLayoutType (string) → layout hint cho riêng loại slide đó. */
    layouts?: Record<string, SlidePresetLayoutHint>;
}

/**
 * Reference đến preset đã chọn cho một slide hoặc presentation.
 * Cho phép override một phần (palette/font/iconSet) mà không cần clone toàn bộ preset.
 */
export interface SlideDesignPresetRef {
    id: string;
    layoutVariant?: string;
    overrides?: {
        palette?: Partial<SlidePresetPalette>;
        font?: string;
        iconSet?: SlidePresetIconSet;
    };
}

export interface Slide {
    slideType: SlideLayoutType;
    title: string;
    content: {
        // Shared
        imagePrompt?: string;
        imageId?: string; // Replaced imageUrl to save space
        // Title
        subtitle?: string;
        // Agenda
        agendaPoints?: string[];
        objective?: string;
        // WarmUp
        activityName?: string;
        activityDescription?: string;
        duration?: string;
        videoUrl?: string;
        // Concept
        explanation?: string;
        // Analysis
        mainPoints?: string[];
        // Comparison
        columns?: { title: string; points: string[] }[];
        // MultipleChoice
        question?: string;
        options?: string[];
        answer?: string;
        // GroupDiscussion
        discussionQuestion?: string;
        discussionPrompts?: string[];
        // DataAnalysis
        chartType?: 'bar' | 'line' | 'pie';
        chartDataPrompt?: string; // Prompt for AI to describe data
        analysisPoints?: string[];
        // Summary
        summaryPoints?: string[];
        nextSteps?: string[];
        // New fields for enhanced interactivity
        points?: { text: string; imagePrompt?: string; imageUrl?: string }[];
        questions?: { question: string; options: string[]; correctAnswer: string; explanation?: string }[];
        videoPrompt?: string;
    };
    speakerNotes: string;
    /** Preset thiết kế áp cho riêng slide này (override preset cấp presentation). */
    designPreset?: SlideDesignPresetRef;
}

export enum PresentationTheme {
  ELEGANT = "Thanh lịch",
  CREATIVE = "Sáng tạo",
  MINIMALIST = "Tối giản",
  PROFESSIONAL = "Chuyên nghiệp",
  VIBRANT = "Sống động",
  CUTE = "Đáng yêu",
}

export interface Presentation {
    id: string;
    title: string;
    slides: Slide[];
    savedDate: string;
    backgroundImagePrompt?: string;
    backgroundImageUrl?: string;
    theme?: PresentationTheme | { mood: string; primaryColor: string; secondaryColor: string; fontStyle: string };
    /** API (camelCase từ decodeRecord) */
    html5Path?: string | null;
    /** Dữ liệu cục bộ / tương thích cũ */
    html5_path?: string | null;
    publicHtml5Url?: string | null;
    public_html5_url?: string | null;
    share_token?: string | null;
    visibility?: 'private' | 'link' | 'public' | 'restricted';
    shareScope?: { type: string; ids: number[] } | null;
    sourceDocumentId?: string;
    /** Preset thiết kế mặc định áp cho cả presentation. Slide có thể override. */
    designPreset?: SlideDesignPresetRef;
}

export enum HomeworkTaskType {
    Reading = "Đọc hiểu",
    Writing = "Viết đoạn văn / Tự luận",
    Research = "Nghiên cứu",
    Questions = "Trả lời câu hỏi / Ngắn",
    Instruction = "Hướng dẫn / Nội dung văn bản",
    ProjectFramework = "Khung Dự án",
    PreClassAssignment = "Nhiệm vụ Chuẩn bị (Flipped)",
    Worksheet = "Phiếu học tập",
    Drawing = "Vẽ sơ đồ",
    MultipleChoiceSingle = "Trắc nghiệm (1 đáp án)",
    MultipleChoiceMulti = "Trắc nghiệm (Nhiều đáp án)",
    TrueFalse = "Đúng - Sai",
    Matching = "Ghép cặp (Match)",
    FillInBlanks = "Điền vào chỗ trống",
    Ordering = "Sắp xếp thứ tự",
    OralResponse = "Luyện nói / Phát âm",
}

export type HomeworkDifficulty = 'Cơ bản' | 'Nâng cao' | 'Thử thách';
export type BloomLevel = 'Nhớ' | 'Hiểu' | 'Vận dụng' | 'Phân tích' | 'Đánh giá' | 'Sáng tạo';

export interface HomeworkTask {
    id?: string;
    taskType: HomeworkTaskType;
    description: string;
    level?: HomeworkDifficulty;
    bloomLevel?: BloomLevel;
    content?: {
        options?: string[];
        optionImages?: string[];
        /** Đáp án đúng: ưu tiên dùng chỉ số / nhãn để tránh lệch chuỗi khi AI trả về */
        correctAnswerIndex?: number;
        correctAnswerIndices?: number[];
        /** Tuỳ chọn: nhãn A–Z (trùng với vị trí trong options) */
        correctAnswerLabel?: string;
        /** Nhiều đáp án: chuỗi nhãn kiểu "A,C,D" (tuỳ chọn, khi AI trả về) */
        correctAnswerLabels?: string;
        correctAnswer?: string | string[];
        hint?: string;
        answerGuide?: string; // Unified field for Sample Answer and AI Grading Criteria
        pairs?: { left: string; right: string }[];
        blanks?: string[];
        isDragDrop?: boolean;
        predefinedAnswers?: string[];
        orderedItems?: string[];
        maxAttempts?: number;
    };
    imagePrompt?: string;
    imageUrl?: string;
    audioUrl?: string;
    videoUrl?: string;
}

export interface OralQuizQuestion {
    id: string;
    type?: 'ShortAnswer' | 'MultipleChoice' | 'TrueFalse';
    questionText: string;
    options?: string[];
    suggestedAnswer: string;
    gradingCriteria: string; // How to score this oral response
    difficulty?: Difficulty;
}

export type OralQuestionTypeId = 'ShortAnswer' | 'MultipleChoice' | 'TrueFalse';

export type OralRevealMode = 'auto_on_timeout' | 'manual_only';

export interface OralQuizScoringRule {
    correctPoints: number;
    incorrectPenalty: number;
}

export interface OralQuiz {
    id: string;
    title: string;
    gradeLevel: GradeLevel;
    subject: string;
    topic: string;
    questions: OralQuizQuestion[];
    config: {
        questionsPerStudent: number;
        timeLimitSeconds?: number;
        estimatedStudentCount: number;
        allowHint?: boolean;
        questionTypes?: OralQuestionTypeId[];
        questionTypeWeights?: Partial<Record<OralQuestionTypeId, number>>;
        revealAnswerMode?: OralRevealMode;
        avoidQuestionOverlap?: boolean;
        scoringRules?: Partial<Record<OralQuestionTypeId, OralQuizScoringRule>>;
    };
    savedDate: string;
    sourceDocumentId?: string;
    sourceLessonPlanId?: string;
}

export interface OralQuizSession {
    id: string;
    oralQuizId: string;
    classId: string;
    userId: string; // Teacher
    selectedStudentIds: string[];
    currentStudentId?: string | null;
    status: 'active' | 'completed';
    results: Record<string, { // StudentId
        score: number;
        maxScore: number;
        note?: string;
        completedAt: string;
        questionResults: { 
            questionId: string; 
            isCorrect: boolean; 
            points: number;
            feedback?: string;
        }[];
    }>;
    startedAt: string;
    endedAt?: string;
}

export interface Homework {
    id: string;
    title: string;
    gradeLevel?: GradeLevel;
    grade_level?: GradeLevel;
    subject?: string;
    classLevel?: string;
    textbookSet?: TextbookSet;
    tasks: HomeworkTask[];
    generalInstructions?: string;
    dueDateSuggestion: string;
    dueDate?: string;
    savedDate: string;
    saved_date?: string;
    sourceLessonPlanId?: string;
    originatingTask?: string;
    showResultToStudent?: boolean;
    submissionThreshold?: number; // % required to submit
    shuffleTasks?: boolean;
    shuffleOptions?: boolean;
    versionName?: string;
    ttsVoice?: string;
    attachments?: Array<{
        name: string;
        url: string;
        type: string;
        size: number;
    }>;
    isSample?: boolean;
    buildMode?: 'ai' | 'manual';
}

export enum ActivityType {
  VIDEO_SCRIPT = "Kịch bản Video/Hoạt hình",
  SONG_LYRICS = "Lời bài hát/Vần thơ",
  STORY = "Câu chuyện kể",
  ROLE_PLAY_SCRIPT = "Kịch bản đóng vai",
}

export interface Activity {
  id: string;
  title: string;
  gradeLevel: GradeLevel;
  grade_level?: GradeLevel;
  subject?: string;
  classLevel?: string;
  textbookSet?: TextbookSet;
  activityType: ActivityType;
  activity_type?: ActivityType;
  objective: string;
  content: string; // The generated script, lyrics, story, etc.
  savedDate: string;
  saved_date?: string;
  sourceDocumentId?: string;
  sourceLessonPlanId?: string;
  buildMode?: 'ai' | 'manual';
}

export interface DrawingLessonStep {
  title: string;
  instruction: string;
  teacherCue: string;
  colorHint: string;
}

export interface DrawingLessonEvaluationCriterion {
  criterion: string;
  indicators: string[];
}

export interface DrawingLessonContent {
  lesson: {
    id?: string;
    title: string;
    ageGroup: string;
    category: string;
    level: string;
    duration: string;
    objective: string;
    subject: string;
    warmup: string;
    coachingNote: string;
    palette: string[];
    prompts: string[];
    steps: DrawingLessonStep[];
  };
  oralGuidance?: string[];
  evaluationCriteria?: DrawingLessonEvaluationCriterion[];
  homeworkExtension?: string;
  aiLessonPlan?: any;
  prompt?: string;
}

export interface DrawingLesson {
  id: string;
  title: string;
  topic?: string;
  ageGroup?: string;
  gradeLevel?: GradeLevel | string;
  objective?: string;
  content?: DrawingLessonContent;
  worksheetUrl?: string;
  outlineUrl?: string;
  sampleUrl?: string;
  savedDate: string;
  visibility?: 'private' | 'link' | 'public' | 'restricted';
  shareToken?: string | null;
  shareLink?: string | null;
  shareScope?: { type: string; ids: number[] } | null;
}

export type FooterInfoKey = 'teacherName' | 'schoolName' | 'className' | 'phoneNumber' | 'email';

export interface FooterItem {
  key: FooterInfoKey;
  label: string;
  include: boolean;
  alignment: 'left' | 'right';
}

export interface CreditLog {
  action: string;
  cost: number;
  timestamp: string; // ISO 8601 string
}

export interface CreditShareLog {
  recipientEmail: string;
  amount: number;
  storageAllocatedMB: number;
  timestamp: string;
// FIX: Add missing properties to satisfy all use cases in the app.
  isBonus?: boolean;
}

export interface CreditPackage {
  id: string;
  category: string; // 'subscription_personal' | 'group_annual' etc.
  billingCycle: 'onetime' | 'monthly' | 'annually' | 'contact';
  name: string;
  credits: number;
  priceVND: number;
  /** Giá gốc (neo giá) - hiển thị gạch ngang khi có */
  originalPriceVND?: number;
  /** Cấp độ AI: basic=tầm trung, premium=cao, advanced=rất cao */
  aiTier?: 'basic' | 'premium' | 'advanced';
  isPremiumEligible?: boolean; // NEW
  canRemoveWatermark?: boolean; // NEW
  tagline: string;
  description: string;
  isPopular?: boolean;
  maxUsers?: number; // For group packages
  maxClasses?: number; // Giới hạn số lớp học
  maxStudents?: number; // Giới hạn tổng số học sinh
  maxChildren?: number; // Giới hạn số hồ sơ con (cho Phụ huynh) - cũng = số tài khoản con quản lý
  maxLearningPlans?: number; // Giới hạn số lộ trình học tập (cho Học sinh/Con)
  /** Career Journey: số nghề "Quan tâm" tối đa lưu được mỗi profile (0 = dùng default settings) */
  maxSavedCareers?: number;
  /** Career Journey: số nghề được compare side-by-side cùng lúc (0 = disable, 999 = unlimited) */
  canCompareCareers?: number;
  maxGroups?: number; // Giới hạn số nhóm Bookai (chia sẻ credit)
  maxGroupMembers?: number; // Giới hạn số thành viên mời vào nhóm Bookai
  canShareCredits?: boolean; // Cho phép chia credit thủ công cho thành viên
  canAllocateGroupMonthly?: boolean; // Cho phép phân bổ credit tháng cho nhóm
  /**
   * Soft Unlimited Chat AI: số tin nhắn chat AI "miễn phí credit" mỗi ngày.
   *  -1 = unlimited (gói Trường học)
   *   0 = tắt soft-unlimited (vẫn trừ credit cho mỗi tin)
   *  >0 = số tin/ngày được miễn credit (vượt rơi về cơ chế credit cũ)
   */
  chatMessagesPerDay?: number;
  creditRolloverLimit?: number; // For subscription packages
  storageLimitMB?: number;
  features?: string[];
}

export interface CouponPreview {
    code: string;
    amountVnd: number;
    baseCredits: number;
    bonusCredits: number;
    totalCredits: number;
    referralStatus?: 'existing' | 'available_to_attach' | 'attached' | string;
    coupon: {
        id: number;
        code: string;
        campaignName?: string | null;
        bonusType: 'fixed_credits' | 'percent_credits' | string;
        bonusValue: number;
        referrerId: number;
        referrerName?: string | null;
        referrerCode?: string | null;
    };
}

export interface PurchaseRecord {
    packageId: string;
    packageName: string;
    purchaseDate: string; // ISO String
    creditsAdded: number;
    baseCreditsAdded?: number;
    bonusCreditsAdded?: number;
    couponCode?: string;
    pricePaid: number;
    transactionCode: string;
    isSubscription?: boolean;
    isPremiumEligible?: boolean;
    canRemoveWatermark?: boolean;
    aiTier?: 'basic' | 'premium' | 'advanced';
    maxGroups?: number;
    maxGroupMembers?: number;
    canShareCredits?: boolean;
    canAllocateGroupMonthly?: boolean;
}


export interface Parent {
    id: string;
    name: string;
    shortName?: string;
    phoneNumber: string;
    email?: string;
    relationship: string; // "Bố", "Mẹ", "Người giám hộ", etc.
}

export interface Student {
  id: string | number;
  name: string; // Tên đầy đủ (bắt buộc) - dùng xuyên suốt
  realName?: string; // Biệt danh/tên gọi (tùy chọn)
  studentId?: string; // Mã học sinh
  joinedAt?: string; // Thời gian tham gia lớp (ISO)
  dob?: string; // Ngày sinh
  /** Trường đang học — quan trọng với lớp dạy thêm/trung tâm (HS đến từ nhiều trường) */
  schoolName?: string;
  email?: string;
  loginCode?: string; // Mã đăng nhập nhanh (Quick Login Code)
  parents?: Parent[]; // Tối đa 2 phụ huynh
  studentAccount?: {
    id: string | number;
    name: string;
    email?: string;
    phone?: string;
  };
}

export interface SessionGrade {
    studentId: string | number;
    grade: number | string;
    attendance: 'present' | 'absent' | 'late' | 'absent_excused';
    note?: string;
}

/** Loại buổi/cột điểm */
export type SessionType = 'oral' | 'quiz_15' | 'quiz_1tiet' | 'midterm' | 'final' | 'other';

export interface ClassSession {
    id: string;
    date: string;
    title: string;
    description?: string;
    /** Loại cột điểm (mặc định 'other') */
    sessionType?: SessionType;
    /** Hệ số cột điểm (mặc định 1) */
    coefficient?: 1 | 2 | 3;
    grades: SessionGrade[];
}

export interface TeachingEvent {
    id: string;
    date: string;        // YYYY-MM-DD
    startTime?: string;  // HH:mm
    endTime?: string;
    title: string;
    classId?: string;
    className?: string;
    type: 'session' | 'assignment_due' | 'exam' | 'other';
    color?: string;
}

export type GradingSystem = 'numeric' | 'letter' | 'pass_fail' | 'none';

/** Đồng giáo viên của 1 lớp (GVCN + GV bộ môn dùng chung roster) — tính năng lớp nhiều GV. */
export interface ClassTeacherMember {
  id: string;
  userId: string;
  name: string | null;
  email: string | null;
  role: 'homeroom' | 'subject_teacher';
  permissionLevel: 'manage' | 'teach';
  subject: string | null;
  isPrimaryOwner: boolean;
  joinedAt: string | null;
}

/** Gợi ý lớp trùng lặp (cùng tên/khối/năm học, cùng do GV này sở hữu chính) — dùng cho Class Merge Tool */
export interface ClassMergeSuggestion {
  id: string;
  name: string;
  academicYear: string;
  gradeLevel: string;
  studentCount: number;
}

/** Preview lời mời tham gia đồng giáo viên (trước khi accept/decline) */
export interface ClassTeacherInvitationPreview {
  className: string | null;
  inviterName: string | null;
  role: string;
  subject: string | null;
  permissionLevel: string;
  studentCount: number;
  expiresAt: string | null;
}

/** Trường học (School Organization) — Phase 5.0 */
export interface SchoolSummary {
  id: string;
  name: string;
  slug: string;
  level: string | null;
  address: string | null;
  contactEmail: string | null;
  contactPhone: string | null;
  logoUrl: string | null;
  verifiedDomain: string | null;
  /** Domain người tạo TỰ KHAI lúc gửi yêu cầu — CHƯA xác minh, khác verifiedDomain. */
  requestedDomain: string | null;
  defaultTextbookSet: string | null;
  /** pending: đang chờ BOOKAI duyệt yêu cầu tạo · active: đã duyệt · rejected: bị từ chối · suspended: tạm dừng */
  status: 'pending' | 'active' | 'rejected' | 'suspended' | string;
  /** Ghi chú của nhân viên BOOKAI khi duyệt/từ chối (lý do từ chối hiện ở đây). */
  adminNote: string | null;
  totalMembers: number;
  myRole: 'admin' | 'teacher' | null;
}

export interface SchoolMemberInfo {
  id: string;
  userId: string;
  name: string | null;
  email: string | null;
  role: 'admin' | 'teacher';
  isFounder: boolean;
  joinedAt: string | null;
}

export interface SchoolInvitationPreview {
  schoolName: string | null;
  inviterName: string | null;
  role: string;
  memberCount: number;
  expiresAt: string | null;
}

/** School Credit Pool — Phase 5.1 */
export interface SchoolCreditQuotaRow {
  userId: string;
  name: string | null;
  email: string | null;
  monthlyQuota: number;
}

export interface SchoolCreditSummary {
  cycleLabel: string;
  adminBalance: number;
  totalRequested: number;
  alreadyAllocated: boolean;
  quotas: SchoolCreditQuotaRow[];
}

/** School Bulk Import — Phase 5.2 */
export interface SchoolBulkImportRow {
  name: string;
  grade_level?: string;
  academic_year?: string;
  gvcn_email: string;
  gvcn_name?: string;
  subject_teachers?: { email: string; subject?: string; name?: string }[];
  student_names?: string[];
}

export interface SchoolBulkImportResult {
  row: number | null;
  status: 'created' | 'pending_link' | 'error';
  classId?: string;
  existingClassId?: string;
  existingClassName?: string;
  gvcnEmail?: string;
  note?: string;
  message?: string;
  /** Mật khẩu tạm cho tài khoản GV vừa được tạo (create_missing_accounts=true) — chỉ trả về 1 LẦN DUY NHẤT, không lưu lại được. */
  tempPasswords?: Record<string, string>;
}

/** School Dashboard — Phase 5.5 */
export interface SchoolMemberActivity {
  userId: string;
  name: string | null;
  email: string | null;
  role: 'admin' | 'teacher';
  assignmentsCreated: number;
  lastActivityAt: string | null;
}

/** Tổ chuyên môn — Phase 6.4: bảng so sánh trong dashboard hiệu trưởng */
export interface SchoolDepartmentComparison {
  id: string;
  name: string;
  memberCount: number;
  contentTotals: Record<string, number>;
  academic: { gradedCount: number; avgGrade: number | null; lowGradeCount: number };
}

export interface SchoolDashboardSummary {
  totalClasses: number;
  totalStudents: number;
  totalMembers: number;
  activeMembers: number;
  memberActivity: SchoolMemberActivity[];
  departments: SchoolDepartmentComparison[];
}

export interface SchoolClassLinkSuggestion {
  id: string;
  schoolId: string;
  existingClassId: string;
  existingClassName: string | null;
  suggestedName: string;
  subjectTeachers: { email: string; subject?: string }[];
  studentNames: string[];
}

/** Tổ chuyên môn (Subject Department) — Phase 6.1-6.6 */
export interface SchoolDepartmentSummary {
  id: string;
  schoolId: string;
  name: string;
  subjectLabel: string | null;
  memberCount: number;
  myRole: 'head' | 'member' | null;
}

export interface SchoolDepartmentMemberInfo {
  id: string;
  userId: string;
  name: string | null;
  email: string | null;
  role: 'head' | 'member';
  joinedAt: string | null;
}

export interface SchoolDepartmentSuggestion {
  userId: string;
  name: string | null;
  email: string | null;
  subject: string | null;
}

export interface SchoolDepartmentJoinRequest {
  id: string;
  userId: string;
  name: string | null;
  email: string | null;
}

export interface SchoolDepartmentReport {
  department: { id: string; name: string; subjectLabel: string | null };
  members: {
    userId: string;
    name: string | null;
    email: string | null;
    role: 'head' | 'member';
    content: Record<string, number>;
    assignmentsCreated: number;
    lastActivityAt: string | null;
  }[];
  contentTotals: Record<string, number>;
  academic: { gradedCount: number; avgGrade: number | null; lowGradeCount: number };
}

export interface Class {
  id: string;
  name: string;
  academicYear: string;
  gradeLevel: GradeLevel | '';
  /**
   * Môn học của lớp (THCS/THPT: GV bộ môn dạy 1 môn nhiều lớp).
   * Rỗng/undefined với Tiểu học = "Lớp chủ nhiệm" (dạy nhiều môn).
   */
  subject?: string;
  /**
   * Phân loại lớp: chính khóa ở trường vs dạy thêm/trung tâm
   * (lớp theo ca, học sinh từ nhiều trường). Rỗng = regular.
   */
  category?: 'regular' | 'tutoring';
  studentIds: string[];
  
  // Refactored Class Model for Hybrid/Flexible classes
  classType: 'physical' | 'virtual' | 'hybrid' | 'online' | 'offline' | 'regular'; // Replacing online/offline
  enrollmentMode?: 'manual' | 'open' | 'invite_only'; // Deprecated: dùng allowJoinFromOutside
  allowJoinFromOutside?: boolean; // On/off: cho phép HS/PH tìm lớp bằng mã và gửi yêu cầu. Off = có mã cũng không thấy
  location?: string; // Physical address or meeting link
  
  inviteCode?: string; // Now used for ALL classes that allow joining
  inviteExpiryDate?: string; // Mã mời: thời hạn gia nhập
  securityQuestion?: string; // Câu hỏi bảo mật (tùy chọn)
  securityAnswer?: string; // Câu trả lời bảo mật (tùy chọn)
  isLocked?: boolean; // Khóa lớp tạm thời (chặn đăng nhập mã)
  
  sessions?: ClassSession[];
  teacherName?: string;
  teacherPhone?: string;
  gradingSystem?: GradingSystem;
  defaultParticipationScore?: number; // Điểm chuyên cần tự động khi hoàn thành nhiệm vụ 'none'/'check_only'

  // --- Lớp nhiều giáo viên (GVCN + GV bộ môn dùng chung roster) ---
  /** Quyền của GV đang đăng nhập đối với lớp này: 'manage' (GVCN/toàn quyền) | 'teach' (GV bộ môn) | null (không xác định) */
  myPermission?: 'manage' | 'teach' | null;
  /** Tổng số giáo viên đang active trong lớp (bao gồm cả chủ sở hữu) */
  teacherCount?: number;
}

export interface Child {
  id: string;
  name: string; // Tên đầy đủ (bắt buộc)
  realName?: string; // Biệt danh/tên gọi (tùy chọn)
  dob: string; // ISO date string or YYYY-MM-DD
  gender: 'male' | 'female' | 'other';
  studentId?: string; // Link to a student account in a class
  avatarUrl?: string; // Ảnh đại diện của con
  avatar?: string | null; // Tương thích với backend
  relationship?: string; // Quan hệ với phụ huynh (Bố, Mẹ...)
}

export interface LearningModule {
  id: string;
  title: string;
  content: string; // Lesson content generated by AI
  imagePrompt?: string; // Prompt for AI image generation
  imageUrl?: string; // URL of the generated or uploaded image
  question: {
    text: string;
    image?: string; // Optional image for the question itself
    options: string[];
    optionImages?: string[]; // Optional images for each option
    correctAnswer: string;
  };
  status: 'pending' | 'completed';
}

export enum PlanStatus {
    OnTrack = "Đúng tiến độ",
    NeedsAttention = "Cần chú ý",
    Completed = "Đã hoàn thành"
}

export enum PlanDifficulty {
    Easy = "Dễ (Làm quen)",
    Medium = "Trung bình (Luyện tập)",
    Hard = "Khó (Thử thách)",
}

export enum PlanDuration {
    Short = "3 Ngày",
    Medium = "1 Tuần",
    Long = "2 Tuần",
}

export interface DailyPlan {
    day: string; // e.g., "Ngày 1"
    modules: LearningModule[];
}

export interface ChildLearningPlan {
  id: string;
  childId: string;
  title: string;
  goal: string;
  dailyPlans: DailyPlan[];
  difficulty: PlanDifficulty;
  duration: PlanDuration;
  startDate?: string; // ISO date string
  createdAt: string; // ISO date string
  planStatus: PlanStatus;
}

export interface LearningHistory {
    id: string;
    planId: string;
    moduleId: string;
    completedAt: string; // ISO date string
    isCorrect: boolean;
}

export interface HistoryStory {
  story: string;
  imagePrompt: string;
}

export interface LiteratureAnalysisGuide {
  guidingQuestions: {
    level: string; // e.g., "Cấp độ 1: Chi tiết & Hình ảnh"
    questions: string[];
  }[];
}

export interface ScienceExplanation {
  simpleAnalogy: string;
  realWorldExample: string;
  scientificExplanation: string;
  imagePrompt: string;
}

export interface ImageResource {
  id: string;
  name: string;
  url: string; // base64 data URL
  createdAt: string; // ISO string
  source: string; // e.g., "Generated in 'Slide Creator: The Solar System'"
}

export interface VideoResource {
  id: string;
  name: string;
  prompt: string;
  uri: string; // Downloadable URI from Veo API
  status: 'processing' | 'completed' | 'failed';
  createdAt: string; // ISO string
  source: string; // e.g., "Generated from Activity: 'Story of Water'"
  operationName?: string;
}

export interface VideoCharacter {
    id: string;
    name: string;
    description: string;
    imagePrompt: string;
    imageUrl?: string;
    status: 'pending' | 'generating' | 'completed' | 'failed';
}

export interface VideoScene {
    id: string;
    title: string;
    prompt: string;
    type?: string;
    status: 'pending' | 'processing' | 'completed' | 'failed';
    videoResourceId?: string;
    videoUrl?: string; // NEW: Field for individual scene video
    interactions?: any[];
}

export interface VideoProject {
    id: string;
    name: string;
    sourceActivityId?: string;
    createdAt: string; // ISO string
    created_at?: string;
    scenes: VideoScene[];
    characters: VideoCharacter[];
    status?: 'draft' | 'processing' | 'completed' | 'failed' | 'partial';
    progress?: string;
    finalVideoUrl?: string;
}


export enum QuickMenuItemKey {
    LessonPlanCreator = 'LessonPlanCreator',
    SlideCreator = 'SlideCreator',
    QuizCreator = 'QuizCreator',
    DocumentLibrary = 'DocumentLibrary',
    StudentDashboard = 'StudentDashboard',
    Pronunciation = 'Pronunciation',
    HistoryStoryteller = 'HistoryStoryteller',
    LiteratureAssistant = 'LiteratureAssistant',
    ScienceExplainer = 'ScienceExplainer',
    ActivityCreator = 'ActivityCreator',
    GameCreator = 'GameCreator',
    HomeworkCreator = 'HomeworkCreator',
    SharedLibrary = 'SharedLibrary',
    ClassManagement = 'ClassManagement',
    TeacherTools = 'TeacherTools',
    ParentDashboard = 'ParentDashboard',
    SKKNCreator = 'SKKNCreator',
    OralQuizCreator = 'OralQuizCreator',
  ScientificSimulationCreator = 'ScientificSimulationCreator',
  ThietKe3DCreator = 'ThietKe3DCreator',
  InteractiveVideo = 'InteractiveVideo',
  DesignCenter = 'DesignCenter',
  AIToolbox = 'AIToolbox',
  MindmapStudio = 'MindmapStudio',
    AILab = 'AILab',
    AIEthics = 'AIEthics',
    AIFactCheck = 'AIFactCheck',
    CareerJourney = 'CareerJourney',
}

export interface QuickMenuItem {
    key: QuickMenuItemKey;
    label: string;
    view: View;
}

export type UserRole = 'teacher' | 'parent' | 'student';

export interface QuickMenuItemConfig {
  key: QuickMenuItemKey;
  label: string;
  view: View;
  roles: UserRole[];
}

export const ALL_QUICK_MENU_ITEMS_CONFIG: QuickMenuItemConfig[] = [
    // Trợ giảng - giáo viên
    { key: QuickMenuItemKey.TeacherTools, label: 'Bảng điều khiển', view: View.TeacherTools, roles: ['teacher'] },
    { key: QuickMenuItemKey.LessonPlanCreator, label: 'Tạo Giáo án', view: View.LessonPlanCreator, roles: ['teacher'] },
    { key: QuickMenuItemKey.SlideCreator, label: 'Tạo Trình chiếu', view: View.SlideCreator, roles: ['teacher', 'parent', 'student'] },
    // Tạo Đề kiểm tra: nghiệp vụ ra đề (ma trận đặc tả, TT 22/2021) — chỉ giáo viên.
    // Phụ huynh/Học sinh dùng "Bài tập & ôn tập" (HomeworkCreator) cho việc ôn luyện.
    { key: QuickMenuItemKey.QuizCreator, label: 'Tạo Đề kiểm tra', view: View.QuizCreator, roles: ['teacher'] },
    { key: QuickMenuItemKey.HomeworkCreator, label: 'Bài tập & ôn tập', view: View.HomeworkCreator, roles: ['teacher', 'parent', 'student'] },
    { key: QuickMenuItemKey.GameCreator, label: 'Tạo trò chơi', view: View.GameCreator, roles: ['teacher'] },
    { key: QuickMenuItemKey.ActivityCreator, label: 'Tạo hoạt động sáng tạo', view: View.ActivityCreator, roles: ['teacher'] },
    { key: QuickMenuItemKey.ClassManagement, label: 'Quản lý lớp học', view: View.ClassManagement, roles: ['teacher'] },
    { key: QuickMenuItemKey.SKKNCreator, label: 'Sáng kiến kinh nghiệm', view: View.SKKNCreator, roles: ['teacher'] },
    { key: QuickMenuItemKey.OralQuizCreator, label: 'Kiểm tra kiến thức', view: View.OralQuizCreator, roles: ['teacher'] },
    { key: QuickMenuItemKey.MindmapStudio, label: 'Sơ đồ tư duy', view: View.MindmapStudio, roles: ['teacher', 'parent', 'student'] },
    { key: QuickMenuItemKey.ScientificSimulationCreator, label: 'Mô phỏng khoa học', view: View.ScientificSimulationCreator, roles: ['teacher', 'parent'] },
    { key: QuickMenuItemKey.ThietKe3DCreator, label: 'Thiết kế ứng dụng 3D', view: View.ThietKe3DView, roles: ['teacher', 'parent'] },
    { key: QuickMenuItemKey.InteractiveVideo, label: 'Video tương tác', view: View.InteractiveVideo, roles: ['teacher', 'parent', 'student'] },
    { key: QuickMenuItemKey.DesignCenter, label: 'Thiết kế thông minh', view: View.DesignCenter, roles: ['teacher', 'parent', 'student'] },
    { key: QuickMenuItemKey.AIToolbox, label: 'Thư viện công cụ AI', view: View.AILab, roles: ['student', 'teacher', 'parent'] },
    { key: QuickMenuItemKey.CareerJourney, label: 'Hành trình khám phá', view: View.CareerJourney, roles: ['student', 'teacher', 'parent'] },
    // Thư viện - tất cả vai trò
    { key: QuickMenuItemKey.DocumentLibrary, label: 'Thư viện của tôi', view: View.DocumentLibrary, roles: ['teacher', 'parent', 'student'] },
    { key: QuickMenuItemKey.SharedLibrary, label: 'Thư viện cộng đồng', view: View.SharedLibrary, roles: ['teacher', 'parent', 'student'] },
    // Học sinh & phụ huynh
    { key: QuickMenuItemKey.ParentDashboard, label: 'Bảng điều khiển phụ huynh', view: View.ParentDashboard, roles: ['parent'] },
    { key: QuickMenuItemKey.StudentDashboard, label: 'Lộ trình học tập', view: View.StudentDashboard, roles: ['student', 'parent'] },
    { key: QuickMenuItemKey.Pronunciation, label: 'Luyện Phát Âm', view: View.Pronunciation, roles: ['student', 'parent'] },
];


export interface Assignment {
    id: string;
    homeworkId?: string;
    videoProjectId?: string;
    classId: string;
    assignedDate: string;
    dueDate?: string;
    
    // New fields for enhanced assignment flexibility
    type?: 'homework' | 'task' | 'announcement';
    title?: string;
    studentIds?: string[]; // If present, only these students see the assignment (differentiation)
    scheduledDate?: string; // When the assignment becomes visible
    allowLateSubmission?: boolean;
    maxAttempts?: number;
    timeLimitMinutes?: number;
    passingGrade?: number;
    isRequired?: boolean;
    isPinned?: boolean;
    status?: 'active' | 'scheduled' | 'closed' | 'recalled';
    instructions?: string; // Specific instructions for this assignment instance
    submissionType?: 'none' | 'check_only' | 'photo' | 'audio_video' | 'any'; // For 'task' type
    attachments?: Array<{
        name: string;
        url: string;
        type: string;
        size: number;
    }>;
    /** Sơ đồ tư duy đính kèm (snapshot) — xem features/mindmap/types MindmapAttachment */
    mindmaps?: any[];
    gradingSystem?: GradingSystem;
}

/** Trạng thái bài nộp: chua-nop | da-nop | da-cham (không dấu, dùng SUBMISSION_STATUS) */
export type SubmissionStatusValue = 'chua-nop' | 'da-nop' | 'da-cham';

export interface Submission {
    id: string;
    assignmentId: string;
    studentId: string;
    /** Trạng thái: chua-nop | da-nop | da-cham (API có thể trả về dạng cũ, dùng isSubmissionGraded/isSubmissionSubmitted) */
    status: SubmissionStatusValue | string;
    submittedDate?: string;
    grade?: number;
    teacherComments?: string;
    /** JSON: { answers?, attachments?: { url, type, name }[] } */
    content?: { answers?: Record<string, any>; attachments?: { url: string; type: string; name: string }[] };
}

/** Mục tiêu học tập cá nhân của học sinh (Deep Workspace). */
export interface StudentGoal {
  id: string;
  title: string;
  current: number;
  target: number;
  icon: string;
  color: string;
  deadline?: string;
  /** Môn học gắn với mục tiêu (để gợi ý nội dung học: luyện đề, lộ trình AI). */
  subject?: string;
  /** Loại mục tiêu: điểm số / kỹ năng / luyện đề / đọc sách. */
  kind?: 'score' | 'skill' | 'practice' | 'reading';
  /** ID lộ trình AI đã gắn cho mục tiêu này (nếu có). */
  linkedPlanId?: string;
}

/** Nhiệm vụ học tập cá nhân tự đặt của học sinh (Deep Workspace). */
export interface StudentTask {
  id: string;
  title: string;
  done: boolean;
  subject?: string;
  type: 'assignment' | 'quiz' | 'study';
}

/**
 * Hồ sơ giảng dạy của giáo viên theo cấu trúc trường học VN
 * (Tiểu học: chủ nhiệm dạy nhiều môn / bộ môn đặc thù; THCS: môn tích hợp;
 * THPT: chuyên sâu 1 môn). Lưu trong edu_user_settings.data phía backend.
 */
export interface TeachingProfile {
  /** Cấp học chính đang dạy */
  schoolLevel: GradeLevel;
  /**
   * Môi trường dạy: trường học chính khóa / dạy thêm-gia sư-trung tâm / cả hai.
   * GV dạy thêm thường dạy trải nhiều cấp-khối (vd Toán 6-12) nên UI dựa vào đây
   * để cho chọn nhiều cấp và không áp cấu trúc "chủ nhiệm" của trường.
   */
  context?: 'school' | 'tutoring' | 'both';
  /** Tất cả cấp đang dạy (bao gồm schoolLevel) — GV trường thường 1, GV dạy thêm có thể nhiều */
  schoolLevels?: GradeLevel[];
  /** Tiểu học: GV chủ nhiệm (dạy hầu hết môn của lớp) hay GV bộ môn đặc thù */
  role?: 'homeroom' | 'subject_teacher';
  /** Danh sách môn đảm nhiệm (tên chuẩn theo educationTaxonomy hoặc tự nhập) */
  subjects: string[];
  /** Các khối đang dạy (1-12), có thể trải nhiều cấp với GV dạy thêm */
  grades: number[];
}

export interface UserSettings {
  id?: string;
  teacherName: string;
  schoolName: string;
  className: string;
  phoneNumber: string;
  email: string;
  /** URL ảnh avatar (từ upload hoặc social login) */
  avatar?: string | null;
  defaultGradeLevel: GradeLevel;
  mainSubject: string;
  defaultTeachingDuration: number; // Changed to number (minutes)
  footerSettings: FooterItem[];
  totalCredits: number;
  usedCredits: number;
  distributedCredits: number;
// FIX: Add missing property to satisfy usage in config.ts.
  distributedStorageMB: number;
  isPremiumManual?: boolean;
  isAffiliateActive?: boolean;
  affiliateStatus?: 'not_applied' | 'pending' | 'approved' | 'rejected' | 'suspended';
  affiliateType?: 'standard' | 'kol' | 'partner';
  affiliateTier?: 'standard' | 'silver' | 'gold' | 'diamond' | 'partner';
  premiumCreditsThreshold?: number; // Threshold for automated premium status
  creditLog: CreditLog[];
  creditShareLog: CreditShareLog[];
  purchaseHistory?: PurchaseRecord[];
  canRemoveWatermark?: boolean;
  groupMembers?: { email: string; invitedAt: string; monthlyQuota: number; }[];
  memberOfGroupId: string | null;
  role: 'teacher' | 'parent' | 'student' | null;
  authType?: 'standard' | 'student_code'; // student_code: đăng nhập mã, không dùng credit, quản lý bởi giáo viên
  quickMenuItems?: QuickMenuItem[];
  showFloatingMenu?: boolean;
  storageLimitMB: number;
  storageUsedMB: number;
  groupStorageLimitMB: number;
  groupStorageUsedMB: number;
  paymentDetails: { packageId: string; transactionCode: string; orderId?: number; package?: CreditPackage; coupon?: CouponPreview['coupon'] | null; baseCredits?: number; bonusCredits?: number; totalCredits?: number; amountVnd?: number } | null;
  adsEnabled?: boolean;
  packageExpiryDate?: string; // ISO String

  // Role-specific data
  classId?: string; // For students
  classes?: Class[];
  students?: Student[];
  children?: Child[];
  childLearningPlans?: ChildLearningPlan[];
  learningHistory?: LearningHistory[];

  // Student-specific: thông tin phụ huynh (chỉ khi authType !== 'student_code')
  parentGuardians?: { name: string; phone: string; relationship?: string }[];

  // Student-specific profile fields
  dob?: string; // Ngày sinh YYYY-MM-DD (dùng để tính tuổi, gợi ý role)
  age?: number;
  gender?: 'male' | 'female' | 'other';
  studentProfileDescription?: string;
  shortTermGoals?: string;
  longTermGoals?: string;
  /** Mục tiêu & nhiệm vụ cá nhân của học sinh (Deep Workspace) — lưu cùng settings blob, đồng bộ backend. */
  studentGoals?: StudentGoal[];
  studentTasks?: StudentTask[];
  greeting?: string;
  notificationSettings?: {
    enableReminders: boolean;
    email: boolean;
    zalo: boolean;
    telegram: boolean;
  };

  /** Mã giới thiệu Affiliate (random, luôn có) */
  affiliateCode?: string | null;
  /** Mã tùy chỉnh dễ nhớ (tuỳ chọn, không lộ SĐT) - VD: minh.giaovien */
  affiliateSlug?: string | null;

  /** Đã xem popup hướng dẫn theo vai trò: ISO date string khi đánh dấu */
  guideWatchedAt?: { teacher?: string; parent?: string; student?: string };

  // System-wide dynamic limits (synced from admin settings)
  maxClasses?: number;
  /** Nhóm Bookai; -1 = không giới hạn */
  maxGroups?: number;
  maxGroupMembers?: number;
  canShareCredits?: boolean;
  canAllocateGroupMonthly?: boolean;
  maxStudents?: number;
  maxChildren?: number;
  maxLearningPlans?: number;
  maxFilesPerAssignment?: number;
  maxFileSizeMB?: number;

  // Quick save preferences for teachers
  preferredClassLevel?: string;
  preferredTextbookSet?: TextbookSet;

  /** Hồ sơ giảng dạy (cấp học, môn, khối) — nguồn prefill cho mọi form tạo học liệu */
  teachingProfile?: TeachingProfile;
}

export interface Notification {
  id: string;
  type: 'deadline' | 'content_ready' | 'info' | 'credit_received' | 'announcement' | 'task';
  message: string;
  timestamp: string; // ISO date string
  isRead: boolean;
  link?: {
    view: View;
    payload?: object;
  };
  icon: 'homework' | 'video' | 'quiz' | 'lesson' | 'game' | 'activity' | 'credit' | 'info' | 'task' | 'announcement' | 'lock';
}

export interface Banner {
  id: number;
  title: string;
  content: string;
  mediaType?: 'html' | 'image' | 'video';
  imageUrl?: string | null;
  videoUrl?: string | null;
  type: 'promo' | 'new_feature' | 'info' | 'maintenance';
  linkUrl?: string | null;
  linkText?: string | null;
  linkPayload?: { view: View; payload?: object } | null;
  dismissMode: 'session' | 'day' | 'forever';
}

export interface UploadTask {
  id: string;
  fileName: string;
  progress: number;
  status: 'uploading' | 'completed' | 'error';
  error?: string;
  type: 'document' | 'image' | 'video';
}

export type SourceItemType = 'document' | 'lessonPlan' | 'presentation' | 'quiz' | 'game' | 'homework' | 'activity';

